import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

const Container = styled.div`
  padding-bottom: 2.4rem;
  width: 600px;
  padding: 2rem;
  min-height: 170px;
  border-radius: 0.8rem;

  border-bottom: 0.2rem solid ${pickColor('gray')};
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  gap: 1rem;

  margin-bottom: 0.6rem;
`;

const Info = styled.div``;

const IconWrapper = styled.div`
  display: flex;
`;

const Wrapper = styled.div`
  display: flex;
  gap: 1.2rem;
`;

const FlexItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;

  margin-bottom: 0.6rem;

  color: ${pickColor('grayLabel')};

  &:not(:first-child) {
    &::before {
      content: '/';
    }
  }
`;

const Desc = styled.div`
  max-width: 65rem;
`;

const CTA = styled.div`
  display: flex;

  justify-content: flex-end;

  gap: 1.2rem;
`;

export { Container, Header, Info, FlexItem, CTA, Desc, Wrapper, IconWrapper };
